import { useState } from "react";
import { Calculator, ChevronDown } from "lucide-react";
import { beText, defaults, rentVsBuy } from "./rentVsBuy";
import { local } from "./calcMath";

const Field = ({ label, value, onChange, testId, step = 1000, max, placeholder }) => (
  <label className="text-[11px] text-[#8C827A] flex-1 min-w-[90px]">{label}
    <input type="number" min="0" max={max} step={step} value={value || ""} placeholder={placeholder} onChange={(e) => onChange(Math.min(max || Infinity, Number(e.target.value) || 0))} data-testid={testId}
      className="block w-full mt-1 h-9 px-2 bg-white border border-[#E2D9CC] text-sm text-[#1C181D] outline-none focus:border-[#3B1B48]" />
  </label>
);

export const MyNumbers = ({ t }) => {
  const d = defaults(t);
  const [open, setOpen] = useState(false);
  const [price, setPrice] = useState(d?.price || 0);
  const [rent, setRent] = useState(d?.rent || 0);
  const [years, setYears] = useState(10);
  if (!d) return null;
  const r = rentVsBuy(t, { price, rent, years: years || 10 });
  const better = r.mine.buy < r.mine.rent ? "Buying" : "Renting";
  return (
    <div className="border border-[#E2D9CC] bg-[#FAF7F2]" data-testid={`calc-mine-${t.slug}`}>
      <button onClick={() => setOpen(!open)} data-testid={`calc-mine-toggle-${t.slug}`} className="w-full flex items-center justify-between px-3 py-2 text-xs text-[#3B1B48] hover:bg-[#F4EFE6] transition-colors">
        <span className="flex items-center gap-1.5"><Calculator className="w-3.5 h-3.5" />Rent vs buy: work out my numbers</span>
        <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="px-3 pb-3 space-y-3">
          <div className="flex flex-wrap gap-2">
            <Field label={`Home price (${t.symbol})`} value={price} onChange={setPrice} testId={`calc-mine-price-${t.slug}`} placeholder={String(d.price)} />
            <Field label={`Rent / month (${t.symbol})`} value={rent} onChange={setRent} step={25} testId={`calc-mine-rent-${t.slug}`} placeholder={String(d.rent)} />
            <Field label="Years" value={years} onChange={setYears} step={1} max={60} testId={`calc-mine-years-${t.slug}`} placeholder="10" />
          </div>
          <div className="text-xs text-[#6B5B4E] space-y-1" data-testid={`calc-mine-result-${t.slug}`}>
            <p>Buying beats renting after <strong className="text-[#3B1B48]">{beText(r)}</strong>.</p>
            <p>Over {r.mine.years} years: renting {local(r.mine.rent, t.symbol)} vs buying {local(r.mine.buy, t.symbol)}. <strong className="text-[#3B1B48]">{better} comes out ahead.</strong></p>
            <p className="text-[10px] text-[#8C827A]">Uses {t.town}'s buying costs ({local(r.upfront, t.symbol)}) and running costs ({local(r.ownMonth, t.symbol)}/month) for your price.</p>
          </div>
        </div>
      )}
    </div>
  );
};
